import React from 'react';
import { useDrop } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    minHeight: '100%', // Ensure there's some height
    display: 'flex',
    flexDirection: 'column',
    flex: '1 0 auto',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#E0EBFF', // Light blue background
    border: '1px dashed #538FFF', // Dashed blue border
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    borderRadius: '4px',
  },
  text: {
    color: '#538FFF', // Blue text
    fontSize: '1.714rem',
    fontWeight: 500,
  },
}));

const DragDropUpload = ({ onUpload, children, className }) => {
  const classes = useStyles();

  const [{ isOver }, drop] = useDrop(() => ({
    accept: [NativeTypes.FILE],
    drop: (item, monitor) => {
      if (onUpload && monitor) {
        const uploadFiles = monitor.getItem().files;
        onUpload(uploadFiles);
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  }));

  return (
    <div ref={drop} className={`${classes.root} ${className || ''}`}>
      {children}
      {isOver && (
        <div className={classes.overlay}>
          <Typography className={classes.text}>Drop images and file here</Typography>
        </div>
      )}
    </div>
  );
};

export default DragDropUpload;
